import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

var VARIANT_ID = 45043311050805;
var GIFT_CARD_PRODUCT_ID = 7857685299253;

var ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
var CHANGE_URL = (window.Theme && Theme.routes && Theme.routes.cart_change_url) || '/cart/change.js';

var _cartCache = null;
var _inFlight = false;

function getEls() {
  return {
    optEssential: document.getElementById('gift-opt-essential'),
    optSignature: document.getElementById('gift-opt-signature'),
    msgWrap: document.getElementById('gift-message-wrap'),
    overlay: document.getElementById('gift-options-overlay')
  };
}

function updateUI(inCart) {
  var els = getEls();
  if (!els.optEssential) return;
  if (inCart) {
    els.optEssential.classList.remove('checked');
    els.optSignature.classList.add('checked');
    els.optEssential.setAttribute('aria-checked', 'false');
    els.optSignature.setAttribute('aria-checked', 'true');
    if (els.msgWrap) els.msgWrap.classList.add('open');
  } else {
    els.optEssential.classList.add('checked');
    els.optSignature.classList.remove('checked');
    els.optEssential.setAttribute('aria-checked', 'true');
    els.optSignature.setAttribute('aria-checked', 'false');
    if (els.msgWrap) els.msgWrap.classList.remove('open');
  }
}

function setLoading(on) {
  var els = getEls();
  if (els.optSignature) els.optSignature.classList.toggle('loading', on);
  if (els.optEssential) els.optEssential.classList.toggle('loading', on);
}

function fetchCart(cb) {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      _cartCache = cart;
      if (cb) cb(cart);
    });
}

function isInCartSync() {
  if (!_cartCache || !_cartCache.items) return false;
  return !!_cartCache.items.find(function (i) { return i.variant_id === VARIANT_ID; });
}

/**
 * Every cart-items-component currently in the DOM (page + drawer) needs its
 * section refreshed, mirroring CartItemsComponent#updateQuantity.
 */
function getSectionsToUpdate() {
  var ids = new Set();
  document.querySelectorAll('cart-items-component').forEach(function (el) {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return Array.from(ids);
}

/**
 * Removes a single cart line by key via /cart/change.js, dispatching a real
 * CartLinesUpdateEvent so theme-drawer-component / cart-items-component morph
 * themselves instead of relying on a page refresh.
 */
function removeWrapLine(lineKey) {
  var sections = getSectionsToUpdate();
  var body = JSON.stringify({
    id: lineKey,
    quantity: 0,
    sections: sections.join(','),
    sections_url: window.location.pathname
  });

  var deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'remove',
      context: 'cart',
      lines: [{ id: lineKey, quantity: 0 }],
      promise: deferred.promise
    })
  );

  return fetch(CHANGE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart.errors) {
        var err = new Error(cart.errors);
        deferred.reject(err);
        document.dispatchEvent(new CartErrorEvent({ error: cart.errors, code: 'INVALID' }));
        throw err;
      }

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          sections: cart.sections,
          items: cart.items,
          itemCount: cart.item_count,
          source: 'gift-wrap',
          didError: false
        }
      });

      return cart;
    })
    .catch(function (error) {
      deferred.reject(error);
      document.dispatchEvent(
        new CartErrorEvent({ error: (error && error.message) || 'Failed to update cart', code: 'SERVICE_UNAVAILABLE' })
      );
      throw error;
    });
}

function checkAndAutoRemoveGiftWrap(cart) {
  var nonWrapItems = cart.items.filter(function (i) { return i.variant_id !== VARIANT_ID; });

  var onlyWrap = nonWrapItems.length === 0;
  var onlyGiftCards = nonWrapItems.length > 0 && nonWrapItems.every(function (i) {
    return i.product_id === GIFT_CARD_PRODUCT_ID;
  });

  if (!onlyWrap && !onlyGiftCards) return;

  var wrapItem = cart.items.find(function (i) { return i.variant_id === VARIANT_ID; });
  if (wrapItem) {
    updateUI(false); // optimistic
    removeWrapLine(wrapItem.key).then(function (updatedCart) {
      _cartCache = updatedCart;
    });
  }

  var els = getEls();
  if (!els.overlay) return;
  els.overlay.classList.add('is-disabled');
  var notice = document.querySelector('.gift-card-notice');
  if (notice) notice.style.display = 'flex';
}

function addToCart() {
  if (_inFlight) return;
  _inFlight = true;
  updateUI(true);

  var sections = getSectionsToUpdate();
  var body = JSON.stringify({
    id: VARIANT_ID,
    quantity: 1,
    sections: sections.join(','),
    sections_url: window.location.pathname
  });

  var deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      // NOTE: inferred shape — no existing cart line key yet, so the variant id
      // is used as the line identifier. Not confirmed against the real
      // add-to-cart component; see note below.
      lines: [{ id: String(VARIANT_ID), quantity: 1 }],
      promise: deferred.promise
    })
  );

  fetch(ADD_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body
  })
    .then(function (r) { return r.json(); })
    .then(function (addResponse) {
      if (addResponse.status || addResponse.errors) {
        var message = addResponse.description || addResponse.errors || 'Failed to add gift wrap';
        var err = new Error(message);
        deferred.reject(err);
        document.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
        updateUI(false);
        _inFlight = false;
        return;
      }

      fetchCart(function (cart) {
        _inFlight = false;

        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            sections: addResponse.sections,
            items: cart.items,
            itemCount: cart.item_count,
            source: 'gift-wrap',
            didError: false
          }
        });

        checkAndAutoRemoveGiftWrap(cart);
      });
    })
    .catch(function (error) {
      deferred.reject(error);
      document.dispatchEvent(
        new CartErrorEvent({ error: (error && error.message) || 'Failed to add gift wrap', code: 'SERVICE_UNAVAILABLE' })
      );
      updateUI(false);
      _inFlight = false;
    });
}

function removeFromCart() {
  if (_inFlight) return;
  var cachedWrap = _cartCache && _cartCache.items
    ? _cartCache.items.find(function (i) { return i.variant_id === VARIANT_ID; })
    : null;

  if (!cachedWrap) {
    _inFlight = true;
    fetchCart(function (cart) {
      var wrapItem = cart.items.find(function (i) { return i.variant_id === VARIANT_ID; });
      if (!wrapItem) { _inFlight = false; return; }
      removeWrapLine(wrapItem.key)
        .then(function (updatedCart) { _cartCache = updatedCart; _inFlight = false; })
        .catch(function () { _inFlight = false; });
    });
    return;
  }

  _inFlight = true;
  updateUI(false);
  removeWrapLine(cachedWrap.key)
    .then(function (updatedCart) { _cartCache = updatedCart; _inFlight = false; })
    .catch(function () { updateUI(true); _inFlight = false; });
}

document.addEventListener('click', function (e) {
  var overlay = document.getElementById('gift-options-overlay');
  if (!overlay || overlay.classList.contains('is-disabled')) return;
  if (e.target.closest('#gift-message-input')) return;

  if (e.target.closest('#gift-opt-essential')) {
    if (isInCartSync()) removeFromCart();
  }
  if (e.target.closest('#gift-opt-signature')) {
    if (isInCartSync()) removeFromCart(); else addToCart();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  var overlay = document.getElementById('gift-options-overlay');
  if (!overlay || overlay.classList.contains('is-disabled')) return;
  if (e.target.closest('#gift-opt-essential')) { e.preventDefault(); if (isInCartSync()) removeFromCart(); }
  if (e.target.closest('#gift-opt-signature')) {
    e.preventDefault();
    if (isInCartSync()) removeFromCart(); else addToCart();
  }
});

// Stay in sync with cart changes made anywhere else in the theme (normal
// add-to-cart buttons, quantity steppers, etc.) by listening for the same
// event everything else now uses.
document.addEventListener(CartLinesUpdateEvent.eventName || 'cart:lines-update', function (event) {
  if (!event.promise) return;
  event.promise
    .then(function () {
      fetchCart(function (cart) {
        updateUI(!!cart.items.find(function (i) { return i.variant_id === VARIANT_ID; }));
        checkAndAutoRemoveGiftWrap(cart);
      });
    })
    .catch(function () {});
});

// Initial sync
fetchCart(function (cart) {
  updateUI(!!cart.items.find(function (i) { return i.variant_id === VARIANT_ID; }));
  checkAndAutoRemoveGiftWrap(cart);
});